// extracted by mini-css-extract-plugin
module.exports = {"block":"Footer_block__8BEgn","colophon":"Footer_colophon__kFfFk","signOff":"Footer_signOff__ByW2L","title":"Footer_title__f9BSV","fadeOut":"Footer_fadeOut__rMJ8X"};